module.exports = __webpack_public_path__ + "img/deliveboo-1.9e379e3e.png";